import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { PageQuoteImporterExcel } from '@/areas/quote-requests/QuoteRequests/ExcelImporter/PageQuoteImporterExcel';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/quote-requests/importer')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ quoteRequestId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const quoteRequestId = Route.useSearch({ select: (search) => search.quoteRequestId });
    return <PageQuoteImporterExcel {...pathParams} negotiationId={undefined} quoteRequestId={quoteRequestId} />;
}
